import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable()
export class QuestionsService {
  headers;
  constructor(private http: HttpClient) {}

  /* Getting Headers */
  getHeaders() {
    this.headers = new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
      "access-token": localStorage.getItem("access-token"),
      client: localStorage.getItem("client"),
      clientid: localStorage.getItem("client_id"),
      expiry: localStorage.getItem("expiry"),
      uid: localStorage.getItem("uid"),
      multipart: "true",
    });
    this.headers["key"] = "key";
  }

  getQuestions(pageNo?): Observable<any> {
    this.getHeaders();
    let query = "/questions";
    if (pageNo != null) {
      query = query + "?page=" + pageNo;
    }
    return this.http.get(environment.offboarding_url + query, {
      headers: this.headers,
      observe: "response",
    });
  }

  createQuestion(data): Observable<any> {
    this.getHeaders();
    return this.http.post(`${environment.offboarding_url}/questions`, data, {
      headers: this.headers,
      observe: "response",
    });
  }

  getQuestion(id: number) {
    this.getHeaders();
    return this.http.get(`${environment.offboarding_url}/questions/${id}`, {
      headers: this.headers,
      observe: "response",
    });
  }

  getQuestionsCategoryDd() {
    this.getHeaders();
    return this.http.get(`${environment.offboarding_url}/questions_category`, {
      headers: this.headers,
      observe: "response",
    });
  }


  updateQuestion(id: any, data: any) {
    this.getHeaders();
    return this.http.put(
      `${environment.offboarding_url}/questions/${id}`,
      data,
      { headers: this.headers, observe: "response" }
    );
  }

  deleteQuestion(id: number) {
    this.getHeaders();
    return this.http.delete(`${environment.offboarding_url}/questions/${id}`, {
      headers: this.headers,
      observe: "response",
    });
  }

  getQuestionsFilterByCategory(category:string) {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/questions?category=${category}`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/services/questions.service.ts